const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY;
const GEMINI_API_URL = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent';

export const generateGemDescription = async (gemData) => {
    try {
        const prompt = `Generate a professional and engaging title and description for a gem with the following specifications:
        - Weight: ${gemData.type}
        - Weight: ${gemData.weight} carats
        - Shape: ${gemData.shape}
        - Color: ${gemData.color}
        - Clarity: ${gemData.clarity}
        - Origin: ${gemData.origin}
        - Treatment: ${gemData.treatment}
        - Certificates: ${gemData.certificate.join(', ')}
        
        Please provide:
        1. A title that is no more than 80 characters long for sell on ebay, highlighting the gem's key characteristics
        2. A detailed description that emphasizes the gem's unique features and value
        
        Format the response as JSON with 'title' and 'description' fields.`;

        const response = await fetch(`${GEMINI_API_URL}?key=${GEMINI_API_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                contents: [{ parts: [{ text: prompt }] }]
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('Gemini API Error:', errorData);
            throw new Error(`Failed to generate description: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();

        if (!data.candidates?.[0]?.content?.parts?.[0]) {
            throw new Error('Invalid response format from Gemini API');
        }

        const generatedText = data.candidates[0].content.parts[0].text;

        try {
            const cleanedText = generatedText
                .replace(/```json\n?/g, '')
                .replace(/```\n?/g, '')
                .trim();
            const result = JSON.parse(cleanedText);
            if (!result.title || !result.description) throw new Error('Missing title or description');
            return {
                title: result.title.length > 80 ? result.title.substring(0, 80) : result.title,
                description: result.description
            };
        } catch (parseError) {
            console.error('Error parsing Gemini JSON response:', parseError);
            const lines = generatedText.split('\n');
            const rawTitle = lines.find(line => line.toLowerCase().includes('title'))?.split(':')[1]?.trim() || 'Untitled';
            return {
                title: rawTitle.length > 80 ? rawTitle.substring(0, 80) : rawTitle,
                description: lines.find(line => line.toLowerCase().includes('description'))?.split(':')[1]?.trim() || 'No description available'
            };
        }
    } catch (error) {
        console.error('Error in generateGemDescription:', error);
        throw error;
    }
};
